export const STATIC_CLASSES = Object.freeze({
	root: 'content1',
	bgSection: 'content1-background-container',
	background: 'content1-background',
	grid: 'content1-title-container',
	title: 'content1-text-block-title',
	textContainer: 'content1-content',
	content: 'content1-text',
	text: 'content1-text-block',
})
